import Modal from '@components/ui/modal/modal';
export default Modal;
